import React from "react";
import { Icon } from "@aws-amplify/ui-react";

import {
  MdDashboard,
  MdModeEditOutline,
  MdAccountBox,
  MdOutlineTableChart,
  MdListAlt,
  MdTask,
  MdPerson,
  MdPersonSearch,
  MdPersonalInjury,
  MdPerson4,
  MdPerson3,
  MdPersonAdd,
} from "react-icons/md";
import { UserRole } from "./data/interfaces";
import { BsFillPersonVcardFill, BsPersonHeart, BsPersonHearts, BsPersonRolodex, BsPersonVcard, BsPersonWheelchair } from "react-icons/bs";

export const baseConfig = {
  projectLink: "/", // GitHub link in the navbar
  docsRepositoryBase: "", // base URL for the docs repository
  titleSuffix: "",
  search: false,
  header: true,
  footer: false,
  footerText: (
    <>
      <span>
        Footer text
      </span>
    </>
  ),

  logo: (
    <>
      <img
        src={process.env.PUBLIC_URL + "/logo.png"}
        alt="logo"
        width="30"
        height="22"
      />
    </>
  ),
};

/// Navigation sidebar
export const appNavs = [
  {
    eventKey: "dashboard",
    icon: <Icon as={MdDashboard} />,
    title: "Dashboard",
    to: "/",
  },
  {
    eventKey: "badanti",
    icon: <Icon as={MdPersonSearch} />,
    title: "Operatori sanitari",
    to: "/os",
    children: [
      {
        eventKey: "bozze-badanti",
        title: "Bozze inserite",
        to: "/os/bozze",
      },
    ],
  },
  {
    eventKey: "clienti",
    icon: <Icon as={MdPersonAdd} />,
    title: "Clienti",
    to: "/clienti",
  },
  {
    eventKey: "task",
    icon: <Icon as={MdTask} />,
    title: "Task",
    to: "/task",
  },
  {
    eventKey: "profile",
    icon: <Icon as={MdAccountBox} />,
    title: "Profilo",
    to: "/profile",
  },
  {
    eventKey: "users",
    icon: <Icon as={MdListAlt} />,
    title: "Gestione utenti",
    to: "/users",
    roles: [UserRole.AMMINISTRATORE]
  },
];
